import { render, staticRenderFns } from "./dataAccessStrategy.vue?vue&type=template&id=7e639134&scoped=true&"
import script from "./dataAccessStrategy.vue?vue&type=script&lang=js&"
export * from "./dataAccessStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e639134",
  null
  
)

export default component.exports